const paymentMethods = {
  mir: {
    value: 'mir',
    title: 'WithdrawToCard | mir',
    icon: 'mir',
    isCardNumberUsed: true,
    isPhoneNumberUsed: false,
  },
  sbp: {
    value: 'sbp',
    title: 'WithdrawToCard | sbp',
    icon: 'sbp',
    isCardNumberUsed: false,
    isPhoneNumberUsed: true,
  },
  visa: {
    value: 'visa',
    title: 'WithdrawToCard | visa',
    icon: 'visa',
    isCardNumberUsed: true,
    isPhoneNumberUsed: false,
  },
  mastercard: {
    value: 'mastercard',
    title: 'WithdrawToCard | mastercard',
    icon: 'mc',
    isCardNumberUsed: true,
    isPhoneNumberUsed: false,
  },
}

export { paymentMethods }
